import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Entry } from 'src/app/models/entry';
import { ActivatedRoute } from '@angular/router';
import { InventoryService } from 'src/app/services/inventory-service';
import { AuthService } from 'src/app/services/auth.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import { EntryLine } from 'src/app/models/entry-line';

@Component({
  selector: 'app-entry-single',
  templateUrl: './entry-single.component.html',
  styleUrls: ['./entry-single.component.css']
})
export class EntrySingleComponent implements OnInit {

  entry:Entry = new Entry();
  line:EntryLine = new EntryLine();
  actualUser:string = "";
  canDelete:boolean = false;
  updateInvoice:boolean = false;

  loading:boolean = false;
  canAuthorize:boolean = false;
  canDelivery:boolean = false;

  constructor( actRoute:ActivatedRoute, private invServ:InventoryService, private auth:AuthService, private toastr:ToastrManager ) {
    actRoute.params.subscribe(params => {
      this.loadEntry(params.id);
    });
  }

  ngOnInit() {
    this.canDelivery = this.auth.can('deliver-entry');
  }

  getTotal() {
    return this.entry.lines.filter(ln => ln.status != 'Cancelado').map(ln => ln.quantity * ln.unit_price * (ln.iva*1 + 1)).reduce((act, ant) => act + ant, 0);
  }

  delete(line = 0) {
    let promise:Promise<any>
    if (line) {
      promise = this.invServ.deleteEntry({
        entry_id: this.entry.id,
        entry_line_id: line,
      });
    } else {
      promise = this.invServ.deleteEntry({
        entry_id: this.entry.id
      });
    }

    this.loading = true;
    promise.then(resp => {
      if (resp.destroyed) {
        this.toastr.successToastr("¡Elemento eliminado correctamente!");
        this.loadEntry(this.entry.id);
      } else {
        this.toastr.errorToastr("¡No puede ser eliminado!");
        this.loading = false;
      }
    });
  }

  loadEntry(id) {
    this.loading = true;
    this.invServ.getEntry(id).then(entry => {
      this.entry = entry;
      this.actualUser = `${this.entry.user.name} ${this.entry.user.last_name}`;
      for (const key in entry.lines) {
        if (entry.lines[key].invoice == '') {
          entry.lines[key].edit = true;
        }
      }
      this.loading = false;

      this.perms(entry);
    });
  }

  saveLine(line) {
    this.loading = true;
    event.preventDefault();
    this.invServ.postInvoiceLine(line).then(line => {
      this.toastr.successToastr(`Guardado exitosamente`);
      this.loadEntry(this.entry.id);
    }).catch(e => {
      this.toastr.errorToastr("No pudo guardarse apropiadamente");
      this.loading = false;
    });
  }

  authorize() {
    this.loading = true;
    this.invServ.authorizeEntry(this.entry).then(entry => {
      this.entry = entry;
      this.perms(entry);
      this.loading = false;
    }).catch(e => {
      this.toastr.errorToastr("La entrada no puede ser autorizada! tal vez se haya eliminado.");
      this.loading = false;
    });
  }

  perms(doc) {
    this.canDelete = this.auth.can('destroy-entry') && this.auth.getActualUser().id == doc.user.id && !doc.authorized;
    this.canAuthorize = this.auth.can('authorize-entry') && doc.status == 'Abierto';
    this.updateInvoice = this.auth.can('update-invoice-line');
  }
}
